<template lang="pug">
form.section.content(v-on:submit.prevent="submit")
  div.missing(v-if="hasInvalidClientStatus") Thank you for signing up. To verify your account, please click the link we sent to your email address. Once verified, you can search for trainers!
  .field
    .control.is-expanded
      input.input(autocomplete="name" placeholder="Name" ref="focus" v-bind:class="[$v.name.$error ? 'is-danger' : 'is-success']" v-model.trim="$v.name.$model")
    .help.is-danger(v-show="$v.name.$error && !$v.name.required") Name is required.
    .help.is-danger(v-show="$v.name.$error && !$v.name.validName") Name is invalid.
  .field
    .level
      .level-left
        .level-item
          span {{ apiClient.email }}
        .level-item
          .button.is-warning(v-if="hasInvalidClientStatus" v-on:click="resendVerificationEmail") Resend verification email
  .field
    .control.is-expanded
      input.input(autocomplete="phone" placeholder="Phone" v-bind:class="[$v.phone.$error ? 'is-danger' : 'is-success']" v-model.trim="$v.phone.$model")
    .help.is-danger(v-show="$v.phone.$error && !$v.phone.validPhone") Phone is invalid.
  .field
    .control.is-expanded
      input.input(autocomplete="goal" placeholder="Goal" type="goal" v-bind:class="[$v.goal.$error ? 'is-danger' : 'is-success']" v-model.trim="$v.goal.$model")
  .field
    .control
      button.button.is-fullwidth.is-primary(type="submit" v-bind:disabled="$v.$invalid") Save &amp; Search for Trainers
</template>

<script>
import { parsePhoneNumberFromString } from 'libphonenumber-js/max'
import { helpers, required } from 'vuelidate/lib/validators'

import AlertMixin from '@/mixins/AlertMixin.vue'
import ApiMixin from '@/mixins/ApiMixin.vue'
import DeviceMixin from '@/mixins/DeviceMixin.vue'

const validName = helpers.regex('invalid', /^.+ .+$/)

export default {
  mixins: [
    AlertMixin,
    ApiMixin,
    DeviceMixin
  ],
  data () {
    return {
      email: null,
      goal: null,
      name: null,
      phone: null
    }
  },
  mounted () {
    this.deviceSetFocus()
    this.email = this.apiClient.email
    this.goal = this.apiClient.training_target
    this.name = this.apiClient.name
    this.phone = this.apiClient.phone
  },
  methods: {
    submit () {
      this.apiUpdateClient(this.apiClient.id, this.goal, this.name, this.phone)
      this.routerPush('/')
    },
    async resendVerificationEmail () {
      await this.apiResendVerificationEmail()
    }
  },
  validations () {
    return {
      email: {},
      goal: {},
      name: {
        required,
        validName
      },
      phone: {
        async validPhone (string) {
          if (string) {
            const phoneNumber = await parsePhoneNumberFromString(string, 'GB')
            return phoneNumber && phoneNumber.isValid() && ['GG', 'JE', 'GB'].includes(phoneNumber.country)
          } else {
            return true
          }
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.missing
  margin-bottom: 0.75rem
</style>
